import React from 'react';
import PropTypes from 'prop-types';

import {
  Button as BsButton,
  Dropdown,
  OverlayTrigger,
  Tooltip,
} from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DropdownToggle from './dropdown_toggle';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';

export default class Button extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    disabledTooltip: PropTypes.node,
    dropdownMenuItems: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.node,
        PropTypes.shape({
          children: PropTypes.node,
          label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
        }),
      ])
    ),
    dropdownMenuRightAligned: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.object,
    iconRight: PropTypes.object,
    label: PropTypes.string,
    outlined: PropTypes.bool,
    plain: PropTypes.bool,
    tooltip: PropTypes.node,
    tooltipProps: PropTypes.object,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    onClick: () => {},
  };

  get buttonVariant() {
    return 'primary';
  }

  render() {
    const {
      children,
      className,
      disabled,
      disabledTooltip,
      dropdownMenuItems, // DEPRECATED: Use components/dropdown instead
      dropdownMenuRightAligned,
      href,
      icon,
      label,
      outlined,
      plain,
      tooltip,
      tooltipProps,
      onClick,
      ...props
    } = this.props;

    let variant = this.buttonVariant;
    if (outlined) {
      variant = 'outline';
    } else if (plain) {
      variant = 'ghost';
    }
    props.variant = variant;
    props.className = className;

    const hasDisabledTooltip = disabled && disabledTooltip;
    props.disabled = disabled;
    if (!hasDisabledTooltip) {
      props.onClick = onClick;
    }

    let iconRight = this.props.iconRight;
    delete props.iconRight;
    if (dropdownMenuItems && (children || label)) {
      iconRight = faCaretDown;
    }

    props['aria-label'] = props['aria-label'] || label;

    // TODO: A cleaner interface would be:
    //   * Only use the `label` prop for the button label
    //   * Use `children` for dropdown menu items instead of `dropdownMenuItems`
    let button = (
      <BsButton {...props}>
        {icon && <FontAwesomeIcon icon={icon} />}
        {children || label}
        {iconRight && <FontAwesomeIcon icon={iconRight} />}
      </BsButton>
    );

    if (href) {
      button = <a href={href}>{button}</a>;
    }

    if (hasDisabledTooltip || tooltip) {
      button = (
        <OverlayTrigger
          overlay={
            <Tooltip id="disabled-button-tooltip">
              {hasDisabledTooltip ? disabledTooltip : tooltip}
            </Tooltip>
          }
          placement="bottom"
          {...tooltipProps}
        >
          <span>{button}</span>
        </OverlayTrigger>
      );
    }

    if (dropdownMenuItems) {
      button = (
        <Dropdown as="span" style={{ position: 'relative' }}>
          <Dropdown.Toggle as={DropdownToggle}>{button}</Dropdown.Toggle>
          <Dropdown.Menu
            align={dropdownMenuRightAligned ? 'end' : 'start'}
            popperConfig={{ strategy: 'fixed' }}
            renderOnMount
          >
            {dropdownMenuItems.map((menuItem, i) => {
              let menuItemChildren, menuItemProps;
              if (React.isValidElement(menuItem)) {
                menuItemChildren = menuItem;
              } else {
                const { label, ...nestedProps } = menuItem;
                menuItemChildren = children || label;
                menuItemProps = { ...nestedProps, 'aria-label': label };
              }

              return (
                <Dropdown.Item key={i} {...menuItemProps}>
                  {menuItemChildren}
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      );
    }

    return button;
  }
}
